/**
 * @name Mesh.js
 */
import * as THREE from "three";
import Simulation from "./Simulation";

import face_vert from "./shader/face.vert";
import color_frag from "./shader/color.frag";
import texture_frag from "./shader/texture.frag";

class Mesh {
    constructor(stage, params) {
        this.stage = stage;
        this.renderer = this.stage.renderer;
        this.params = params;

        this.__init();
    }

    /**
     * @name __init
     */
    __init() {
        this.scene = new THREE.Scene();
        this.camera = new THREE.Camera();
        // this.__setCameleonLayer();
        this.__setMesh();
    }

    /**
     * @name __setMesh
     */
    __setMesh() {
        this.simulation = new Simulation(this.stage, this.params);

        this.mesh = new THREE.Mesh(
            new THREE.PlaneGeometry(2.0, 2.0),
            new THREE.RawShaderMaterial({
                vertexShader: face_vert,
                fragmentShader: color_frag,
                uniforms: {
                    velocity: {
                        value: this.simulation.fbos.vel_0.texture
                    },
                    boundarySpace: {
                        value: new THREE.Vector2()
                    },
                    uTexture01: {
                        value: TEXTURE[0]
                    },
                    uTexture02: {
                        value: TEXTURE[1]
                    },
                    uTexture03: {
                        value: TEXTURE[2]
                    },
                    uTexture04: {
                        value: TEXTURE[3]
                    },
                    uTextureAspect: {
                        value: TEXTURE[0].image.width / TEXTURE[0].image.height
                    },
                    uText01: {
                        value: TEXTURE[4]
                    },
                    uText02: {
                        value: TEXTURE[5]
                    },
                    uTextAspect: {
                        value: TEXTURE[4].image.width / TEXTURE[4].image.height
                    },
                    uScreenAspect: {
                        value: this.params.size.aspect
                    }
                },
            })
        );

        this.scene.add(this.mesh);
    }

    /**
     * @name __raf
     */
    __raf() {
        this.simulation.__raf();
        this.renderer.setRenderTarget(null);
        this.renderer.render(this.scene, this.camera);
    }

    /**
     * @name __resize
     */
    __resize() {
        this.simulation.__resize();
        this.mesh.material.uniforms.uScreenAspect.value = this.params.size.aspect;
    }
}

export default Mesh;